(function () {
    'use strict';

    angular
        .module("skillsApp")
        .factory("jsReportService", jsReportService);

    function jsReportService($q, $translate, $interpolate, $filter, $timeout, jsreportUrl, cgbusyService) {

        var service = {
            getClusterActionsIndividualsUserQualitiesReport: getClusterActionsIndividualsUserQualitiesReport,
            getDepartmentsReport: getDepartmentsReport,
            getDepartmentsUserQualitiesReport: getDepartmentsUserQualitiesReport,
            getEmployeesUserQualitiesReport: getEmployeesUserQualitiesReport,
            getReportDetails: getReportDetails,
            getSkillsReport: getSkillsReport,
            getUserQualitiesReport: getUserQualitiesReport,
            getUserQualityReport: getUserQualityReport
        };

        return service;
        
        function _createRequest(templateId, data) {
            return {
                template: { shortid: templateId },
                data: data,
                options: { language: $translate.use() }
            };
        }

        function _render(request, name_prefix, type) {
            name_prefix = name_prefix || $translate.instant('report');
            var filename = $interpolate(name_prefix + '-{{date | date:"yyyy-MM-dd_hh-mm-ss"}}.' + type)({ date: new Date() });
            
            jsreport.headers.Authorization = "Basic " + btoa("skills:skills");
            jsreport.serverUrl = jsreportUrl;

            return cgbusyService.blockUI(
                jsreport.renderAsync(request)
                    .then(
                    function (res) { $timeout(function () { res.download(filename); return res; }, 0); },
                    function (res) { $timeout(function () { return $q.reject(res); }, 0); }
                    )
            );
        }

        function getClusterActionsIndividualsUserQualitiesReport(type, reportInfo, items) {
            var templateId = type === 'pdf' ? 'B1VGOqpTz' : 'r1sCTi-CG';
            var data = {
                reportInfo: reportInfo,
                items: items
            };

            var request = _createRequest(templateId, data);
            var name_prefix = $translate.instant('individual_skills');

            return _render(request, name_prefix, type);
        }

        function getDepartmentsReport(type, reportInfo, items) {
            var templateId = type === 'pdf' ? 'HkNyYkC6f' : 'BJpwjVyRM';
            var data = {
                reportInfo: reportInfo,
                items: items
            };

            var request = _createRequest(templateId, data);
            var name_prefix = $translate.instant('departments_report');

            return _render(request, name_prefix, type);
        }

        function getDepartmentsUserQualitiesReport(type, reportInfo, items) {
            var templateId = type === 'pdf' ? 'HktGqnp6G' : 'ryFpMhb0z';
            var data = {
                reportInfo: reportInfo,
                items: items
            };

            var request = _createRequest(templateId, data);
            var name_prefix = $translate.instant('skills') + '-' + reportInfo.departmentName + '-' + reportInfo.roleName;

            return _render(request, name_prefix, type);
        }

        function getEmployeesUserQualitiesReport(type, reportInfo, items) {
            var templateId = type === 'pdf' ? 'B1MTBAT6f' : 'HJuCrnZ0G';

            var data = {
                reportInfo: reportInfo,
                items: items
            };

            var request = _createRequest(templateId, data);
            var name_prefix = reportInfo.employeeName + '-' + $translate.instant('skills');

            return _render(request, name_prefix, type);
        }

        function getReportDetails(type, reportInfo, items) {
            var templateId = type === 'pdf' ? 'ryvklXyCz' : 'r1uHuj-0G';
            var data = {
                reportInfo: reportInfo,
                items: items
            };

            var request = _createRequest(templateId, data);
            var name_prefix = reportInfo.title;
            return _render(request, name_prefix, type);
        }

        function getSkillsReport(type, reportInfo, items) {
            var templateId = type === 'pdf' ? 'Sk9Jge1Cf' : 'ryhLpzgAf';

            var data = {
                reportInfo: reportInfo,
                items: items
            };

            var request = _createRequest(templateId, data);
            var name_prefix = $translate.instant('skills_report');

            return _render(request, name_prefix, type);
        }

        function getUserQualitiesReport(type, items, reportInfo) {
            var templateId = type === 'pdf' ? 'Hkeesv89f' : 'S1oYCwGcG';
            var data = {
                reportInfo: reportInfo,
                items: items
            };
            
            var request = _createRequest(templateId, data);
            var name_prefix = data.reportInfo.name + '-' + $translate.instant('skills');
            return _render(request, name_prefix, type);
        }

        function getUserQualityReport(item) {
            var request = _createRequest('r1UP5L7hG', { item: item });
            var name_prefix = item.employeeName + '-' + item.actionName;
            return _render(request, name_prefix, 'pdf');
        }
    }
})();